import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ItalicIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Italic`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M12.667 1.917a.75.75 0 0 1 0 1.5H10.52l-3.438 9.166h2.251a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5H5.48l3.438-9.166H6.667a.75.75 0 0 1 0-1.5h6Z"
    />
  </Icon>
);
